import { type FC } from "react";
import ReactJson from "react-json-view";
import styled from "styled-components";
import { AnimateAppearanceWrapper } from "../../../../components/animate-appearence/AnimateAppearanceWrapper";
import { Typography, TypographyVariant } from "../../../../components/ui-kit";
import { SupplierApiType } from "../../../../util/types";
import { Column, FieldRow, Section } from "../../components/DetailsConstructor";

interface SupplierDetailsProps {
  data: SupplierApiType;
}

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  width: 100%;
  padding: 30px;
  @media (max-width: 767px) {
    padding: 14px;
  }
  background: #ffffff;
  border: 1px solid #eeeeee;
  border-radius: 10px;
`;

const SupplierDetails: FC<SupplierDetailsProps> = ({ data }) => {
  return (
    <AnimateAppearanceWrapper>
      <Container>
        <ContentWrapper>
          <Typography variant={TypographyVariant.HEADER2}>General </Typography>
          <Section>
            <Column>
              <FieldRow label="Name" value={data.name} />
              <FieldRow label="Email" value={data.email} />
            </Column>
            <Column>
              <FieldRow label="Website" value={data.website} />
              <FieldRow
                label="Phone"
                value={
                  data.phoneCode && data.phoneNumber
                    ? data.phoneCode + data.phoneNumber
                    : ""
                }
              />
            </Column>
          </Section>

          <Typography variant={TypographyVariant.HEADER2}>Address </Typography>
          <Section>
            <Column>
              <FieldRow label="Post code" value={data?.address?.zipCode} />
              <FieldRow label="Country" value={data?.address?.country} />
              <FieldRow label="City" value={data?.address?.city} />
            </Column>

            <Column>
              <FieldRow
                label="Address line 1"
                value={data?.address?.addressLine1}
              />
              <FieldRow
                label="Address line 2"
                value={data?.address?.addressLine2}
              />
              <FieldRow label="Address name" value={data?.address?.name} />
            </Column>
          </Section>
          <Typography variant={TypographyVariant.HEADER2}>Raw data </Typography>
          <Section>
            <Column>
              <ReactJson
                src={data}
                collapsed
                enableClipboard
                name={"supplier"}
              />
            </Column>
          </Section>
        </ContentWrapper>
      </Container>
    </AnimateAppearanceWrapper>
  );
};

export default SupplierDetails;
